import { Component, OnDestroy, OnInit } from '@angular/core';
// import * as shape from 'd3-shape';
import { StatisticsService } from 'app/shared/services/statistics.service';
import { UserService } from 'app/shared/services/user.service';
import { Subscription } from 'rxjs';
import { TaskStatusService } from 'app/shared/services/task-type.service';

@Component({
  selector: 'task-overview-chart-widget',
  template: '<div></div>',
})
export class TaskOverviewChartWidgetComponent implements OnInit, OnDestroy {

  chartConfig: any;
  users: number[] = [];

  selectedUsersChanged: Subscription;
  
  constructor(private statisticsService: StatisticsService, private userService: UserService, private taskStatusService: TaskStatusService) { 
    
    this.chartConfig = {
      currentRange  : 'TW',
      xAxis         : true,
      yAxis         : true,
      gradient      : false,
      legend        : false,
      showXAxisLabel: false,
      xAxisLabel    : 'Days',
      showYAxisLabel: false,
      yAxisLabel    : 'Tasks',
      scheme        : {
          domain: ['#42BFF7', '#C6ECFD', '#C7B42C', '#AAAAAA'],
      },
      onSelect      : (ev) => {
          // console.log(ev);
      },
      supporting    : {
          currentRange  : '',
          xAxis         : false,
          yAxis         : false,
          gradient      : false,
          legend        : false,
          showXAxisLabel: false,
          xAxisLabel    : 'Days',
          showYAxisLabel: false,
          yAxisLabel    : 'Tasks',
          scheme        : {
              domain: ['#42BFF7', '#C6ECFD', '#C7B42C', '#AAAAAA'],
          },
          // curve         : shape.curveBasis,
      },
    };
  }

  ngOnInit() { 
    // set up subscription to display data when user selection changed
    this.selectedUsersChanged = this.userService.onSelectedUsersChanged.subscribe((users) => {
      const u = users || [this.userService.getCurrentUserId()];
      const s = this.users || [];
      // tslint:disable-next-line:only-arrow-functions
      const match = u.length === s.length && u.sort().every(function(value, index) { return value === s.sort()[index]; });
      if (!match){
        this.users = u;
        this.updateWidget(this.users);
      }
      this.updateWidget(this.users);
    });

    // display data for current user
    this.updateWidget([this.userService.getCurrentUserId()]);
  }

  ngOnDestroy(){
    this.selectedUsersChanged?.unsubscribe();
  }

  onlyCurrentUser(users: number[]): boolean{
    if (users){
      return ((users.length === 1) && (users[0] === this.userService.getCurrentUserId()));
    }
    else{
      return false;
    }
  }

  updateWidget(users: number[]){
  
  //   const chartData = new NgxChartData();
  //   chartData.title = 'Tasks Overview';
  //   chartData.ranges = [
  //     new KeyValuePair('TW', 'This Week'),
  //     new KeyValuePair('LW', 'Last Week'),
  //     new KeyValuePair('2W', '2 Weeks Ago'),
  //   ];

  //   const baseUrl = (this.onlyCurrentUser(users)) ? '/tasks/my' : '/tasks/all';

  //   // add main chart data
  //   chartData.mainChart = {};
  //   chartData.ranges.forEach((range) => {
  //   chartData.mainChart[range.key] = this.getDataSeriesForMainChart(range.key, users);
  //   });

  //   // add supporting chart data
  //   chartData.supporting = [];
  //   const taskstatuses = this.taskStatusService.taskStatusTypeList.map((status) => status.name);
    
  //   // check if due has been included in the taskstatuses, if not add it as we need it for the stats...
  //   if (taskstatuses.indexOf('due') === -1){
  //     taskstatuses.splice(1, 0, 'due');
  //   }

  //   // check if created has been included in the taskstatuses, if not add it as we need it for the stats...
  //   if (taskstatuses.indexOf('created') === -1){
  //     taskstatuses.unshift('created');
  //   }   

  //   taskstatuses.forEach((status) => {
  //     chartData.supporting[status] = this.getSupportingChartData(status, chartData.ranges, users, baseUrl);
  //   });

  //   this.chartData = chartData;
  // }

  // getDataSeriesForMainChart(range: string, users: number[]): any[]{
  //   const data = [];
  //   const kvp = this.getArrayOfDatesForRange(range);
  //   kvp.forEach((v) => {
  //     const series = this.getSeriesForMainChart(v.key, v.value, users);
  //     data.push({ name: v.key, series });
  //   });
  //   return data;
  // }

  // // for the main chart on the tasks overview we are interested in all tasks, and those which have been completed
  // getSeriesForMainChart(name: string, date: string, users: number[]): any[]{
  //   const series = [];
  //   const all = this.statisticsService.getTaskStat('', date, date, users);
  //   const completed = this.statisticsService.getTaskStat('completed', date, date, users);
  //   series.push({ name: 'changed tasks', value: all });
  //   series.push({ name: 'completed tasks', value: completed });
  //   return series;
  // }

  // getSupportingChartData(state: string, ranges: KeyValuePair[], users: number[], baseUrl: string){

  //   const totals = {};
  //   const chart = {};
   
  //   // ngx.data = [];
  //   ranges.forEach((range) => {
  //     const dates = this.getArrayOfDatesForRange(range.key);
  //     if (dates && dates.length > 0){        
  //       // get individual counts for each day within the specified range (inclusive)
  //       let totalCount = 0;
  //       const series = [];
  //       dates.forEach((d) => {
  //         const stat = this.statisticsService.getTaskStat(state, d.value, d.value, users);
  //         series.push({ name: d.key, value: stat});
  //         totalCount  = totalCount + stat;
  //       });
  //       const data = { name: state.toUpperCase(), series};
  //       chart[range.key] = [data];
  //       totals[range.key] = totalCount;
  //     }
  //   });

  //   // TODO:  My or all, need to add filter when it becomes available
  //   // const route = (this.onlyCurrentUser(users)) ? '/tasks/my' : '/tasks/all';
  //   const route = baseUrl;
   
  //   return {title: state.toUpperCase(), route, totals, chart};
  // }

  // getArrayOfDatesForRange(range: string): KeyValuePair[]{
  //   let offset: number;
  //   switch (range){
  //     case 'TW':
  //       offset = 0;
  //       break;
  //     case 'LW':
  //       offset = -1;
  //       break;
  //     case '2W':
  //       offset = -2;
  //       break;
  //   }
  //   const kvp: KeyValuePair[] = [];
  //   const dates = this.statisticsService.getDateRangeForWeek(offset);
  //   dates.forEach((date) => {
  //     kvp.push(new KeyValuePair(date.key, date.value));
  //   });
  //   return kvp;
  // }
  }
}
